<div
  class="product-card eq-flex eq-flex-col eq-h-full eq-overflow-hidden eq-group"
>
  <div class="content-wrapper eq-flex eq-flex-col eq-justify-between eq-h-full">
    <div class="eq-flex eq-flex-col ">
      <h3 *ngIf="data?.Title" class="eq-mb-4 eq-text-heading5-m eq-font-bold lg:eq-text-heading5">{{ data?.Title }}</h3>
      <p *ngIf="data?.Description" class="eq-text-body-sm-m lg:eq-text-body-sm">
        {{ data?.Description }}
      </p>
    </div>
    <a *ngIf="data?.Link?.text" hybridHref href="{{ data?.Link?.href }}" [attr.label]="data?.Link?.text" [target]="data?.Link?.target" [attr.rel]="data?.Link?.target == '_blank' ? 'noopener' : null" class="eq-mt-6 eq-flex eq-items-center eq-gap-x-3">
      <div class="eq-block eq-text-body-sm-m lg:eq-hidden">
        <div> {{ data?.Link?.text }} </div>
      </div>
      <div
        class="eq-hidden eq-absolute eq-ease-out eq-transition-all eq-duration-800 group-hover:eq-translate-x-0 group-hover:eq-opacity-100 group-hover:eq-static lg:eq-inline-block lg:eq-opacity-0 lg:eq-text-body-sm"
      >
        <div class="eq-line-clamp-2"> {{ data?.Link?.text }} </div>
      </div>
      <div
      class="eq-flex eq-items-center eq-transition-transform eq-duration-800 group-hover:eq-ml-auto"
    >
      <i class="eq-icon-arrow_right eq-text-i-32"></i>
    </div>
    </a>
  </div>
</div>